module.exports = __webpack_public_path__ + "img/timg.cb93ebe5.jpg";